import { Component, Input, OnInit } from '@angular/core';
import { Organization } from '../../../../model/organization';
import { Device } from '../../../../model/device';
import { DevicesService } from '../../../../services/devices.service';
import { DeviceFilters } from '../../../../model/filters/device-filters';
import { SortOrder } from '../../../../model/sort-order';
import {finalize} from 'rxjs/operators';

@Component({
  selector: 'app-organization-devices',
  templateUrl: './organization-devices.component.html',
  styleUrls: ['./organization-devices.component.scss']
})
export class OrganizationDevicesComponent implements OnInit {

  @Input()
  public organization: Organization;

  public devices: Device[];
  public totalDevices: number;
  public loadingDevices: boolean;

  public rows = 10;
  public first = 0;

  public currentFilters: DeviceFilters;

  constructor(private devicesService: DevicesService) {
    this.currentFilters = new DeviceFilters();
  }

  ngOnInit(): void {
    this.currentFilters.organizationUuids = [this.organization.uuid];
    this.loadDevices(0, 10);
  }

  private loadDevices(offset: number, limit: number): void {
    this.loadingDevices = true;
    this.devicesService.getDevices(offset, limit, this.currentFilters)
      .pipe(finalize(() => this.loadingDevices = false))
      .subscribe(response => {
      this.devices = response.devices;
      this.totalDevices = response.totalElements;
    });
  }

  onPageChange(event: any): void {
    this.currentFilters.sortField = event.sortField;
    this.currentFilters.sortOrder = event.sortOrder < 0 ? SortOrder.DESCENDING : SortOrder.ASCENDING;
    this.loadDevices(event.first / event.rows, event.rows);
  }

}
